import { render, staticRenderFns } from "./CreateSchoolYear.vue?vue&type=template&id=5d3f4261&scoped=true"
import script from "./CreateSchoolYear.vue?vue&type=script&lang=js"
export * from "./CreateSchoolYear.vue?vue&type=script&lang=js"
import style0 from "./CreateSchoolYear.vue?vue&type=style&index=0&id=5d3f4261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f4261",
  null
  
)

export default component.exports